/**
 * Returns chat-log messages stored in redux.
 *
 * @param {IReduxState} state - The redux state.
 * @returns {IChatLogState}
 */
export function getChatLogMessages(state) {
    return state['features/chat-log'] ?? [];
}
/**
 * Checks whether at least one chat-log message exists.
 *
 * @param {IReduxState} state - The redux state.
 * @returns {boolean}
 */
export function hasChatLogMessages(state) {
    return getChatLogMessages(state).length > 0;
}
/**
 * Downloads the chat log as a text file.
 *
 * @param {IReduxState} state - The redux state.
 * @returns {boolean} True when a file was downloaded.
 */
export function downloadChatLogFile(state) {
    const chatMessages = getChatLogMessages(state);
    if (!chatMessages.length) {
        return false;
    }
    const chatText = chatMessages.map(msg => {
        const timestamp = new Date(msg.timestamp).toLocaleTimeString();
        const displayName = msg.displayName || 'Unknown';
        return `[${timestamp}] ${displayName}: ${msg.message}`;
    }).join('\n');
    const now = new Date();
    const roomName = state['features/base/conference']?.room ?? 'conference';
    const sanitizedRoomName = String(roomName).replace(/[^a-zA-Z0-9-_]/g, '_');
    const dateString = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`
        + `_${String(now.getHours()).padStart(2, '0')}-${String(now.getMinutes()).padStart(2, '0')}-${String(now.getSeconds()).padStart(2, '0')}`;
    const fileName = `chat_${sanitizedRoomName}_${dateString}.txt`;
    const file = new File([chatText], fileName, {
        type: 'text/plain',
        lastModified: Date.now()
    });
    // @ts-ignore -- URL.createObjectURL/revokeObjectURL not typed in this ts-loader context
    const url = URL.createObjectURL(file);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    // @ts-ignore -- URL.createObjectURL/revokeObjectURL not typed in this ts-loader context
    URL.revokeObjectURL(url);
    return true;
}
